export default __webpack_public_path__ + "bf52bb7e7aa3e1e99ab5032f3a2deb8d.ttf";